<!--
  * @Editor: chenqy
  * @Description: 
  * @Date: 2021-07-20 10:46:07
  * @LastEditors: Chenqy
  * @LastEditTime: 2022-04-21 11:17:32
 -->
<template>
  <!-- 搜索树 -->
  <div class="teas-body-tree">
    <div class="teas-body-tree-head">
      <el-input v-model="searchName" class="teas-body-tree-input" suffix-icon="el-icon-search" placeholder="请输入姓名查询" />
    </div>
    <div class="teas-vr-scroll" v-loading="loading" element-loading-text="加载中...">
      <DsfVirtualScroll class="ds-tree-box">
        <dsf-tree
          :ref="name"
          show-check-box="1"
          :is-design="isDesign"
          :props="defaultProps"
          :default-open-series="defaultOpenSeries"
          :is-async="smsData.lazy ? '1' : '0'"
          :default-expanded-keys="expandedKeys"
          :filter-node-method="filterNode"
          :check-on-click-node="true"
          node-key="globalId"
          :sql-url="smsData.url"
          :async-sql-url="smsData.url"
          :search-sql-url="smsData.searchUrl"
          :rightIstree="true"
          @check-node="currNodeChange"
          @data-loaded="dataLoaded"
        />
      </DsfVirtualScroll>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfPlatformTeasWirteTree",
  ctrlCaption: "短信首页树",
  mixins: [$mixins.control],
  props: {
    name: {
      type: String,
      require: true,
    },
    smsData: {
      type: Object,
      default() {
        return {};
      },
    },
    defaultOpenSeries: {
      type: String,
      default: "0",
    },
  },
  created() {
    // 获取树数据
    if (!this.smsData.url) {
      return;
    } else {
      if (this.smsData.url.length == 0) {
        return;
      }
    }
  },
  data() {
    return {
      defaultProps: { children: "children", label: "name", otherName: false },
      expandedKeys: [], // 展开节点
      icons: [
        {
          code: "!@[children]",
          iconExpand: "icon-shiyongwendang",
          iconFold: "icon-shiyongwendang",
          color: "#6594dc",
        },
        {
          code: "!!@[children]",
          iconExpand: "icon-dakai",
          iconFold: "icon-wenjianjia",
          color: "#c78511",
        },
      ], // 树图标
      treeData: [], // 树数据
      searchName: "", // 搜索名字
      loading: false,
    };
  },
  watch: {
    searchName(val) {
      this.$refs[this.name].filter(val);
    },
  },
  methods: {
    // 筛选树中的内容
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 节点被展开时触发的事件 -> 数据加载  匹配回显数据
    dataLoaded(tree, tabIndex) {
      // 如果是弹窗编辑
      var type = this.$dialog?.dialogArgs?.type;
      var messageId = this.$dialog?.dialogArgs?.messageId;
      if (messageId && (type == "edit" || type == "resend" || type == "reply")) {
        this.$emit("call-back", this);
      }else {
        // 异步加载数据时 
        this.$emit("call-back", this, { tree, tabIndex})
      }
    },
    // 选中树节点事件
    currNodeChange({ args, target }) {
      if (this.isDesign) {
        return;
      }
      //  当前选择的node
      let selNode = args.node;
      // 当前节点的node
      let nodeData = target.$refs.tree.getNode(selNode.globalId) || target.$refs.tree2.getNode(selNode.globalId);
      // 勾选或取消
      if (nodeData.checked) {
        // 当前已选
        let checks = target.$refs.tree.getCheckedNodes();
        let checks2 = target.$refs.tree2?.getCheckedNodes();
        let checksData = [];
        checks2?.forEach((item) => {
          if (item.type == "user") {
            checksData.push(item);
          }
        });
        let concatCheck = _.concat(checks, checksData);
        // 当前选择的是目录  不是用户 就请求接口 查询目录子级 所有用户
        if (selNode.type != "user") {
          target.$refs.tree2?.setCheckedKeys[selNode.globalId];
          target.$refs.tree.setCheckedKeys[selNode.globalId];
          this.getUserInfosByRootId(selNode, concatCheck);
        } else {
          this.$emit("handle-add", this, concatCheck, nodeData.checked);
        }
      } else {
        this.$emit("handle-delete", this.name, selNode, nodeData.checked);
      }
    },
    getUserInfosByRootId({ id, type }, checks) {
      // let userLoading = dsf.layer.loading();
      this.$http
        .get("/sms/sms-info/getUserInfosByRootId", {
          rootId: id,
          type,
        })
        .done((re) => {
          if (re.success) {
            let resData = _.uniqBy(_.concat(checks, re.data), "globalId");
            let peos = [];
            resData.forEach((item) => {
              if (item.type == "user") {
                peos.push(item);
              }
            });
            // console.log('没去重', resData)
            this.$emit("handle-add", this, peos);
          } else {
            dsf.layer.message(re.message, false);
          }
        })
        .error((re) => {
          dsf.layer.message(re.message, false);
        })
        .always(() => {
          // dsf.layer.closeLoading(userLoading);
        });
    },
    // 树图标
    getIconClass(iconData, nodeData) {
      if (dsf.express.eval(iconData.code, nodeData.data)) {
        if (nodeData.expanded) {
          return [iconData.iconExpand || ""];
        } else {
          return [iconData.iconFold || ""];
        }
      }
      return [""];
    },
    // 格式化 页签配置参数
    formatName(data) {
      let format = this.smsData.configParams?.split(",");
      let other = "";
      format.forEach((item) => {
        other += dsf.isDef(data[item]) ? data[item] : "";
      });
      return other ? "(" + other + ")" : "";
    },
  },
});
</script>
